import { Input, Component, OnInit, Inject, ChangeDetectionStrategy, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup,FormArray, Validators} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../../../../environments/environment';
import { CommonService } from '../../../../../Service/common/common-service.service';
import{FileAttachmentClass}from '../../../../../Class/common/file-attachment/file-attachment-class';
import{Da9000Class}from '../../../../../Class/da9000/da9000-class';

import { HttpEventType } from '@angular/common/http';
import { from } from 'rxjs';
import {DatePipe} from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'kt-file-attach-detail',
  templateUrl: './file-attach-detail.component.html',
  styleUrls: ['./file-attach-detail.component.scss']
})
export class FileAttachDetailComponent implements OnInit {
    
  currentUrl:string;

  icoDoc: string;
  icoImg: string;
  icoPdf: string;
  icoPpt: string;
  icoTxt: string;
  icoUnknown: string;
  icoXls: string;
  icoZip: string;

  // Form:FormGroup;
  private fileList: Array<any> = [];
  private newAttribute: any = {'FileId' : 0,'FileNameSelected': '' ,'FileNameServer':'','Folder':'','FileIcon':''};

  constructor(private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
    private objCommonService:CommonService,public dialog: MatDialog,private layoutUtilsService: LayoutUtilsService,private modalService: NgbModal, public dialogRef: MatDialogRef<FileAttachDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public ParamData: any, private changeDetectorRef: ChangeDetectorRef ) {
   }

  ngOnInit() {
    this.currentUrl = environment.baseUrl.replace("api/", "");
    this.icoDoc = "UploadFiles/DocManager/Default/doc.png";
    this.icoImg = "UploadFiles/DocManager/Default/img.png";
    this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";
    this.icoPpt = "UploadFiles/DocManager/Default/ppt.png";
    this.icoTxt = "UploadFiles/DocManager/Default/txt.png";
    this.icoUnknown = "UploadFiles/DocManager/Default/unknown.png";
    this.icoXls = "UploadFiles/DocManager/Default/xls.png";
    this.icoZip = "UploadFiles/DocManager/Default/zip.png";
  }
  
  ngAfterViewInit(): void {

    if(this.ParamData.AutoId > 0)
    {
    var objDa9000Class = new Da9000Class();   
    objDa9000Class.TableName=this.ParamData.TableName;
    objDa9000Class.AutoId = this.ParamData.AutoId;

    this.objCommonService.SelectAttachments(objDa9000Class).subscribe(data=>{
 
          this.fileList = data;
          this.changeDetectorRef.detectChanges();
       })
    }
  };

  public uploadFile = (files,index:number) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.objCommonService.TempFileCreate(formData).subscribe(event=>
      {
        if (event.type === HttpEventType.UploadProgress)
          var progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          var message = 'Upload success.';
          var savedfilename=event.body.dbPath;  
          var geturl='UploadFiles/DocManager/temp/'+savedfilename;         
          // this.imageURL = environment.baseUrl.replace("api/", "") + 'UploadFiles/DocManager/temp/'+savedfilename;     

          // var fileName =(<HTMLFormElement>document.getElementById("fileName")) ;
          // fileName.value = fileToUpload.name;

          this.newAttribute = [];
          this.newAttribute.FileId = 0;
          this.newAttribute.FileNameSelected = fileToUpload.name;
          this.newAttribute.FileNameServer = savedfilename;
          this.newAttribute.Folder = 'UploadFiles/DocManager/temp/';

          if(savedfilename.endsWith("doc") == true || savedfilename.endsWith("docx") == true)
          {
            this.newAttribute.FileIcon = this.icoDoc;
          }
          else if(savedfilename.endsWith("xls") == true || savedfilename.endsWith("xlsx") == true)
          {
            this.newAttribute.FileIcon = this.icoXls;
          }
          else if(savedfilename.endsWith("txt") == true || savedfilename.endsWith("csv") == true)
          {
            this.newAttribute.FileIcon = this.icoTxt;
          }
          else if(savedfilename.endsWith("pdf") == true)
          {
            this.newAttribute.FileIcon = this.icoPdf;
          }
          else if(savedfilename.endsWith("ppt") == true || savedfilename.endsWith("pptx") == true)
          {
            this.newAttribute.FileIcon = this.icoPpt;
          }
          else if(savedfilename.endsWith("zip") == true || savedfilename.endsWith("rar") == true)
          {
            this.newAttribute.FileIcon = this.icoZip;
          }
          else if(savedfilename.endsWith("jpg") == true || savedfilename.endsWith("jpeg") == true|| savedfilename.endsWith("png") == true|| savedfilename.endsWith("gif") == true|| savedfilename.endsWith("tif") == true)
          {
            this.newAttribute.FileIcon = this.icoImg;
          }
          else
          {
            this.newAttribute.FileIcon = this.icoUnknown;
          }

          this.fileList.push(this.newAttribute);

          this.changeDetectorRef.detectChanges();
        }
      }

    )
  }

  OpenFile(file)
  {
    window.open(file);
  }

  removeAttachment(index)
  {
    this.fileList.splice(index, 1);
  }



  Close()
  {
    this.dialogRef.close(`${""}`);
  }
}


